var NewUserRewardPanel = require("clover/panel/NewUserRewardPanel")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var Panel = xClass("VipPrivilegesInfoPanel", NewUserRewardPanel, function () {
    return cc.CSLoader.createNode("cocos/vip_privileges_info_info_panel.csb")
})

var resList = [
    "cocos/vip_privileges_info_info_panel.csb",,
    "cocos/vip_privileges_info_bottom_offbottom_light_x.csb",
    "cocos/vip_privileges_info.plist"
    //"font/zzgftongxin_40_redstroke.fnt",
]

Panel.asyncCreate = function (onCloseCallback, fail, cancel) {
    function onSuccess() {
        let panel = Panel.create( onCloseCallback)
        panel.popup()
    }
    preloadWithLoading(resList, onSuccess, fail, cancel)
}
Panel.prototype.ctor = function (onCloseCallback) {
    var self = this
    self.onCloseCallback = onCloseCallback
    self.init()
}
Panel.prototype.init = function () {
    var self = this
    BasePanel.prototype.init.call(self)

    let title = self.getChildByName("title")
    title.setPositionX(title.getPositionX() - 8)

    let close = UIGroupButton.create(self.getChildByName("btn_close"))
    PushBounceAnim.create(close)
    close.on(UIButtonEvent.Click, function () {
        self.onClose()
    })
}

Panel.prototype.cleanup = function () {
    unloadResList(resList)
    NewUserRewardPanel.prototype.cleanup.call(this)
}
module.exports = Panel